module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div class="cnc-inner-container">\n    ';
 if (templateId) { ;
__p += '\n        <div class="zmags-viewer-container event-start" style="' +
__e( viewerStyle ) +
'" data-template="' +
__e( templateId ) +
'"></div>\n    ';
 } else { ;
__p += '\n    <div class="zmags-viewer-container event-start" style="' +
__e( viewerStyle ) +
'"\n        data-experience="' +
__e( experienceId ) +
'" \n        data-fit-in-height="' +
__e( fitInHeight ) +
'" \n        data-group-disable="' +
__e( groupsDisable ) +
'"\n        ></div>\n    ';
 } ;
__p += '\n</div> ';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/viewer/cnc/ExperienceCncViewer.tpl
// module id = 2875
// module chunks = 0